module.exports = __webpack_public_path__ + "static/media/Antenas-Acessorios.baf39f7c.jpg";